/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFacebookIcon16Regular = forwardRef('LogoFacebookIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.708 8 11 6H9V5c0-.52.318-1.029 1.136-1.029h.83V2.13S10.213 2 9.492 2c-1.504 0-2.487.912-2.487 2.562V6H5v2h2.005v6H9V8h1.708Z" })));
});
